import React from 'react';
export function ChartCard({
  title,
  subtitle,
  children,
  className
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`rounded-2xl border border-line bg-white p-4 shadow-card ${className ?? ''}`} data-id="element-107" data-mp="3vvz501isk74n">
      <div className="mb-3" data-id="element-108" data-mp="4gt3qpcj82mb">
        <h3 className="text-sm font-semibold tracking-tight" data-id="element-109" data-mp="4i34jmarrown">{title}</h3>
        {subtitle && <p className="text-[12px] text-ink-soft" data-id="element-110" data-mp="9gnxr1rlt8bl">{subtitle}</p>}
      </div>
      {children}
    </div>;
}